const products = [
  {
    id: 1,
    category: "classic tees",
    name: "GUNS N' ROSES APPETITE FOR DESTRUCTION DESTROYED TEE",
    artist: "GUNS N' ROSES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR093DST_600x.jpg?v=1657173845",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR093DSTDETAIL1_600x.jpg?v=1657173845",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR093DSTDETAIL7_600x.jpg?v=1657173845",
    ],
  },
  {
    id: 2,
    category: "classic tees",
    name: "THE B52'S TOUR '92 ACID",
    artist: "THE B52",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "ACID",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWB52002TACIDFRONT_600x.jpg?v=1656569884",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWB52002TACIDDETAIL1_600x.jpg?v=1656569884",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWB52002TACIDBACK_600x.jpg?v=1656569884",
    ],
  },
  {
    id: 3,
    category: "classic tees",
    name: "STEVIE NICKS '91 TOUR",
    artist: "STEVIE NICKS",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSN013T_600x.jpg?v=1656396172",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSN013TDETAIL1_600x.jpg?v=1656396172",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSN013TBACK_600x.jpg?v=1656396172",
    ],
  },
  {
    id: 4,
    category: "classic tees",
    name: "JERRY GARCIA TIE DYE",
    artist: "JERRY GARCIA",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "FADED RAINBOW",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJG001TDFRONT_600x.jpg?v=1655954207",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJG001TDDETAIL1_600x.jpg?v=1655954207",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJG001TDBACK_600x.jpg?v=1655954207",
    ],
  },
  {
    id: 5,
    category: "classic tees",
    name: "BOB MARLEY LIVE IN CONCERT",
    artist: "BOB MARLEY",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBM054T_600x.jpg?v=1655947621",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBM054TDETAIL2_600x.jpg?v=1655947621",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBM054TDETAIL6_600x.jpg?v=1655947621",
    ],
  },
  {
    id: 6,
    category: "classic tees",
    name: "AC/DC FLICK OF THE SWITCH '83-'84",
    artist: "AC/DC",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC077TFRONT_600x.jpg?v=1655953900",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC077TDETAIL1_600x.jpg?v=1655953900",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC077TBACK_600x.jpg?v=1655953900",
    ],
  },
  {
    id: 7,
    category: "classic tees",
    name: "THE WHO LONG LIVE ROCK",
    artist: "THE WHO",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWWH038TFRONT_600x.jpg?v=1655444238",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWWH038TDETAIL1_600x.jpg?v=1655444238",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWWH038TBACK_600x.jpg?v=1655444238",
    ],
  },
  {
    id: 8,
    category: "classic tees",
    name: "IRON MAIDEN WORLDWIDE TOUR",
    artist: "IRON MAIDEN",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWIM037TFRONT_600x.jpg?v=1655444381",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWIM037TDETAIL1_600x.jpg?v=1655481752",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWIM037TBACK_600x.jpg?v=1655481752",
    ],
  },
  {
    id: 9,
    category: "classic tees",
    name: "PINK FLOYD THE DIVISION BELL",
    artist: "PINK FLOYD",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPF104TFRONT_600x.jpg?v=1655445156",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPF104TDETAIL1_600x.jpg?v=1655445156",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPF104TBACK_600x.jpg?v=1655445156",
    ],
  },
  {
    id: 10,
    category: "classic tees",
    name: "ALICE COOPER SNAKEBITE DESTROYED TEE",
    artist: "ALICE COOPER",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWAC021DST_600x.jpg?v=1655445359",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWAC021DSTDETAIL1_600x.jpg?v=1655445359",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWAC021DSTDETAIL3_600x.jpg?v=1655445359",
    ],
  },
  {
    id: 11,
    category: "classic tees",
    name: "MÖTLEY CRÜE FRANKENSTEIN",
    artist: "MÖTLEY CRÜE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMC053TFRONT_600x.jpg?v=1654836103",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMC053TDETAIL1_600x.jpg?v=1654836103",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMC053TBACK_600x.jpg?v=1654836103",
    ],
  },
  {
    id: 12,
    category: "classic tees",
    name: "SLAYER BLACK MAGIC DESTROYED TEE",
    artist: "SLAYER",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
    "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSL019DST_600x.jpg?v=1654663910",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSL019DSTDETAIL7_600x.jpg?v=1654663910",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSL019DSTDETAIL6_600x.jpg?v=1654663706",
    ],
  },
  {
    id: 13,
    category: "classic tees",
    name: "LED ZEPPELIN SWAN SONG",
    artist: "LED ZEPPELIN",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "SUN BLEACH",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
    "NOW EVEN MORE THAN BEFORE, ENJOY ADDITIONAL HOLES, DISTRESS, TEARS AND IMPERFECTIONS THROUGHOUT THE BODY AND GRAPHIC. FOR THOSE WHO LIKE TO LIVE ON THE EDGE, AND AREN'T AFRAID OF MAKING THEIR MARK ON THEIR PRIZED POSSESSIONS. INSPIRED BY A VINTAGE UNISEX FIT, OUR DESTROYED TEE  RUNS SLIM, YET TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWLZ062TFRONT_600x.jpg?v=1654062148",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWLZ062TDETAIL1_600x.jpg?v=1654062148",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWLZ062TBACK_600x.jpg?v=1654062148",
    ],
  },
  {
    id: 14,
    category: "classic tees",
    name: "BEACH BOYS THE WARMTH OF THE SUN",
    artist: "BEACH BOYS",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "TANGERINE TIE DYE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBB046TD_600x.jpg?v=1652852578",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBB046TDDETAIL2_600x.jpg?v=1652852689",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBB046TDDETAIL5_600x.jpg?v=1652852689",
    ],
  },
  {
    id: 15,
    category: "classic tees",
    name: "THE POLICE NORTH AMERICAN TOUR",
    artist: "THE POLICE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPE020TFRONT_600x.jpg?v=1650588488",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPE020TDETAIL1_600x.jpg?v=1650588488",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPE020TBACK_600x.jpg?v=1650588488",
    ],
  },
  {
    id: 16,
    category: "classic tees",
    name: "KISS ROCK AND ROLL OVER",
    artist: "KISS",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "PEACH FUZZ",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWKS063T_600x.jpg?v=1650579706",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWKS063TDETAIL1_600x.jpg?v=1650579706",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWKS063TDETAIL4_600x.jpg?v=1650579706",
    ],
  },
  {
    id: 17,
    category: "classic tees",
    name: "STEVE MILLER BAND IN CONCERT",
    artist: "STEVE MILLER",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "SUN BLEACH",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSMB002Tfront2_600x.jpg?v=1650579472",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSMB002TDETAIL1_600x.jpg?v=1650579472",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSMB002TBACK_600x.jpg?v=1650579472",
    ],
  },
  {
    id: 18,
    category: "classic tees",
    name: "TUPAC CALIFORNIA LOVE",
    artist: "TUPAC",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWTU035T_600x.jpg?v=1650335611",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWTU035TDETAIL1_600x.jpg?v=1650335611",
      " https://cdn.shopify.com/s/files/1/1409/0868/products/MWTU035TDETAIL4_600x.jpg?v=1650335611",
    ],
  },
  {
    id: 19,
    category: "classic tees",
    name: "ICE CUBE IT WAS A GOOD DAY",
    artist: "ICE CUBE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWICE002TDETAIL9_600x.jpg?v=1649739397",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWICE002TDETAIL4_600x.jpg?v=1649739550",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWICE002TDETAIL7_600x.jpg?v=1649739432",
    ],
  },
  {
    id: 20,
    category: "classic tees",
    name: "MOTÖRHEAD DR. ROCK",
    artist: "MOTÖRHEAD",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMH029TDETAIL4_600x.jpg?v=1649108242",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMH029TDETAIL1_600x.jpg?v=1649108242",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMH029TDETAIL2_600x.jpg?v=1649108240",
    ],
  },
  {
    id: 21,
    category: "classic tees",
    name: "THE DOORS STRANGE DAYS",
    artist: "THE DOORS",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "SUN BLEACH",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDO052TDETAIL5_600x.jpg?v=1646962177",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDO052T_600x.jpg?v=1646962191",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDO052TDETAIL1_600x.jpg?v=1646962191",
    ],
  },
  {
    id: 22,
    category: "classic tees",
    name: "NOTORIOUS B.I.G. UNBELIEVABLE",
    artist: "NOTORIOUS B.I.G",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBIG041T_600x.jpg?v=1646031206",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBIG041TDETAIL1_600x.jpg?v=1646031206",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBIG041TDETAIL2_600x.jpg?v=1646031206",
    ],
  },
  {
    id: 23,
    category: "classic tees",
    name: "MEGADETH ON TOUR",
    artist: "MEGADETH",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMG005TFRONT_600x.jpg?v=1643092431",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMG005TDETAIL1_600x.jpg?v=1643092431",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMG005TBACK_600x.jpg?v=1643092431",
    ],
  },
  {
    id: 24,
    category: "classic tees",
    name: "BRUCE SPRINGSTEEN BORN IN THE U.S.A. WORLD TOUR",
    artist: "BRUCE SPRINGSTEEN",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBR001TFRONT_600x.jpg?v=1637043571",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBR001TDETAIL1_600x.jpg?v=1637043571",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBR001TBACK_600x.jpg?v=1637043570",
    ],
  },
  {
    id: 25,
    category: "classic tees",
    name: "PRINCE AND THE REVOLUTION WHEN DOVES CRY",
    artist: "PRINCE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPR002T_600x.jpg?v=1635914789",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPR002TDETAIL8_600x.jpg?v=1635914789",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPR002TDETAIL5_600x.jpg?v=1635914789",
    ],
  },
  {
    id: 26,
    category: "crop tees",
    name: "DEF LEPPARD HIGH N' DRY CROP",
    artist: "DEF LEPPARD",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDL031CPFRONT_600x.jpg?v=1653463372",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDL031CPDETAIL1_600x.jpg?v=1653463372",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDL031CPBACK_600x.jpg?v=1653463372",
    ],
  },
  {
    id: 27,
    category: "crop tees",
    name: "BLONDIE WORLD TOUR 1977 CROP",
    artist: "BLONDIE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBL037CP_600x.jpg?v=1647562111",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBL037CPDETAIL1_600x.jpg?v=1647562111",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBL037CPDETAIL4_600x.jpg?v=1647562111",
    ],
  },
  {
    id: 28,
    category: "crop tees",
    name: "JOHN LENNON GIVE PEACE A CHANCE CROP",
    artist: "JOHN LENNON",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJL027CP_600x.jpg?v=1640845805",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJL027CPDETAIL1_600x.jpg?v=1640845805",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJL027TDETAIL4_27429d85-2c94-459d-a95c-a9201a82183e_600x.jpg?v=1640845805",
    ],
  },
  {
    id: 29,
    category: "crop tees",
    name: "FLEETWOOD MAC LIVE 1980 CROP",
    artist: "FLEETWOOD",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWFM007CP_600x.jpg?v=1634709453",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWFM007CPDETAIL1_600x.jpg?v=1634709453",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWFM007TDETAIL2_44be9128-740b-4b67-bc08-850d4e143d9e_600x.jpg?v=1634709435",
    ],
  },
  {
    id: 30,
    category: "crop tees",
    name: "DAVID BOWIE STARDUST CROP",
    artist: "DAVID BOWIE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDB049CP_600x.jpg?v=1628230059",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDB049CPDETAIL1_600x.jpg?v=1628230059",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDB049TDETAIL2_ab78c4fd-4116-44c9-a949-aaa9476ee885_600x.jpg?v=1628230095",
    ],
  },
  {
    id: 31,
    category: "crop tees",
    name: "AEROSMITH DREAM ON CROP",
    artist: "AEROSMITH",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/AEROCROPFRONT_600x.jpg?v=1615490622",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/AEROCROPDETAIL2_600x.jpg?v=1615490621",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/AEROCROPBACK_600x.jpg?v=1615490620",
    ],
  },
  {
    id: 32,
    category: "crop tees",
    name: "MICHAEL JACKSON THRILLER CROP",
    artist: "MICHAEL JACKSON",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "BLACK PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJ001CP_600x.jpg?v=1594340264",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJ001CPDETAIL1_600x.jpg?v=1594340265",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWJ001CPDETAIL2_600x.jpg?v=1594340265",
    ],
  },
  {
    id: 33,
    category: "crop tees",
    name: "POISON OPEN UP AND SAY AHH! CROP",
    artist: "POISON",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "BLACK PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPN003CP_600x.jpg?v=1588017458",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPN003CPDETAIL1_600x.jpg?v=1588017471",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWPN003TDETAIL2_c9de7823-7276-4f33-b20c-8cefb3f7106d_600x.jpg?v=1588017471",
    ],
  },
  {
    id: 34,
    category: "crop tees",
    name: "METALLICA SKULL ON FIRE CROP",
    artist: "METALLICA",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "BLACK PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM060CP-2_600x.jpg?v=1585856639",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM060CPDETAIL2-2_600x.jpg?v=1585856639",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM060CPDETAIL1_600x.jpg?v=1585856639",
    ],
  },
  {
    id: 35,
    category: "crop tees",
    name: "QUEEN FREDDIE CROP",
    artist: "QUEEN",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWQ002CP_600x.jpg?v=1585202143",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWQ002CPDETAIL1_600x.jpg?v=1585202143",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWQ002CPDETAIL3_600x.jpg?v=1585202143",
    ],
  },
  {
    id: 36,
    category: "crop tees",
    name: "MISFITS FIEND CLUB CROP",
    artist: "MISFITS",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMF020CP_600x.jpg?v=1576101626",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMF020CPDETAIL2_600x.jpg?v=1576101626",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMF020CPDETAIL1_600x.jpg?v=1576101626",
    ],
  },
  {
    id: 37,
    category: "crop tees - sweatshirt",
    name: "ROLLING STONES ZIP CROPPED SWEATSHIRT",
    artist: "ROLLING STONES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    extraInfo: "PATCHED SWEATSHIRT WITH CUSTOM ZIPPER INLAY",
    price: 265,
    color: "DIRTY BLACK",
    material: "50% cotton / 50% polyester",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWRS181CPSW_600x.jpg?v=1572921077",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWRS181CPSWDETAIL-2_600x.jpg?v=1572921077",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWRS181CPSWDETAIL-1_600x.jpg?v=1572921077",
    ],
  },
  {
    id: 38,
    category: "tank tops",
    name: "HARLEY EAGLE LACE TANK",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWHD038LT_600x.jpg?v=1601759738",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWHD038LTDETAIL1_600x.jpg?v=1601759766",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWHD038LTDETAL3_600x.jpg?v=1601759766",
    ],
  },
  {
    id: 39,
    category: "tank tops",
    name: "WILLIE NELSON FLOWERS LACE TANK",
    artist: "WILLIE NELSON",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWWN009LT_600x.jpg?v=1578360755",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWWN009LTDETAIL1_600x.jpg?v=1578360750",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWWN009LTDETAIL2.2_600x.jpg?v=1578360755",
    ],
  },
  {
    id: 40,
    category: "tank tops",
    name: "THE DOORS IN CONCERT CUT TANK",
    artist: "THE DOORS",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 175,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDO028OS_600x.jpg?v=1576545328",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDO028OSDETAIL1_600x.jpg?v=1576545445",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDO028OSDETAIL2.2_600x.jpg?v=1576545445",
    ],
  },
  {
    id: 41,
    category: "longsleeves tees",
    name: "RAMONES GABBA GABBA HEY LONGSLEEVE",
    artist: "RAMONES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 215,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR064LS_600x.jpg?v=1643953117",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR064LSDETAIL1_600x.jpg?v=1643953135",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR064LSDETAIL3_600x.jpg?v=1643953135",
    ],
  },
  {
    id: 42,
    category: "longsleeves tees",
    name: "METALLICA RULZ LONGSLEEVE",
    artist: "METALLICA",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 215,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM068LSFRONT_600x.jpg?v=1593191581",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM068LSDETAIL1.1_600x.jpg?v=1593191581",
    ],
  },
  {
    id: 43,
    category: "longsleeves tees",
    name: "BLACK SABBATH CROSS LONGSLEEVE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 215,
    color: "BLACK PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBS042LS2_600x.jpg?v=1588891287",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBS042LSDETAIL1_600x.jpg?v=1588891287",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM068LSDETAIL2_600x.jpg?v=1593191581",
    ],
  },
  {
    id: 44,
    category: "longsleeves tees",
    name: "ANTHRAX U4EEAAH LONGSLEEVE",
    artist: "ANTHRAX",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 215,
    color: "OFF WHITE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWAX002LS_600x.jpg?v=1587761132",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWAX002LSDETAIL1_600x.jpg?v=1587761135",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWAX002LSDETAIL2_600x.jpg?v=1587761135",
    ],
  },
  {
    id: 45,
    category: "longsleeves tees",
    name: "GUNS 'N ROSES SHIELD LONGSLEEVE",
    artist: "GUNS 'N ROSES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 215,
    color: "BLACK PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR070LS-1_600x.jpg?v=1573503989",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR070LSDETAIL4-1_600x.jpg?v=1573503989",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR070LSDETAIL1-1_600x.jpg?v=1573503989",
    ],
  },
  {
    id: 46,
    category: "longsleeves tees",
    name: "BOB MARLEY SONGS OF FREEDOM LONGSLEEVE",
    artist: "BOB MARLEY",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 215,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBM043LS_600x.jpg?v=1576864976",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBM043LSDETAIL1_600x.jpg?v=1576865026",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWBM043LSDETAIL3_600x.jpg?v=1576865026",
    ],
  },
  {
    id: 47,
    category: "classic sweatshirts",
    name: "GRATEFUL DEAD BEAR'S CHOICE CLASSIC CREW SWEATSHIRT TIE DYE",
    artist: "GRATEFUL DEAD",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 395,
    color: "RAINBOW TIE DYE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "OUR CLASSIC FIT SWEATSHIRT IS COMPOSED OF HEAVY GAUGE, PREMIUM COTTON. EACH PIECE IS UNIQUELY KNIT, DYED, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES. THIS PIECE WILL RUN SLIM, YET TRUE TO SIZE FOR MOST, SIMILAR TO OUR CLASSIC UNISEX TEES. MEN CAN GET THEIR TRADITIONAL SIZE FOR A SLIM FIT - OR SIZE UP 1 FOR A MORE RELAXED LOOK. WOMEN MAY SIZE DOWN 1 FOR A SMALLER FIT - OR SELECT THEIR STANDARD SIZE FOR A MORE RELAXED, COMFORTABLE VIBE.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGD141CSWTIEDYE_600x.jpg?v=1645685138",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGD141CSWTIEDYEDETAIL1_600x.jpg?v=1645685138",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGD141CSWTIEDYEDETAIL3_600x.jpg?v=1645685138",
    ],
  },
  {
    id: 48,
    category: "classic sweatshirts",
    name: "AC/DC HIGHWAY TO HELL BOLT SWEATSHIRT",
    artist: "AC/DC",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 225,
    color: "COAL",
    material: "50% cotton / 50% polyester",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC040SW_600x.jpg?v=1637776637",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC040SWDETAIL1_600x.jpg?v=1637776637",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC040SWDETAIL4_600x.jpg?v=1637776637",
    ],
  },
  {
    id: 49,
    category: "classic sweatshirts",
    name: "DAVID BOWIE ALADDIN SANE SWEATSHIRT",
    artist: "DAVID BOWIE",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 225,
    color: "PINK PIGMENT",
    material: "50% cotton / 50% polyester",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDB031SW_600x.jpg?v=1637782060",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDB031SWDETAIL1_600x.jpg?v=1637782077",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWDB031SWDETAIL3_600x.jpg?v=1637782077",
    ],
  },
  {
    id: 50,
    category: "classic sweatshirts",
    name: "RAMONES ROCKAWAY BEACH SWEATSHIRT",
    artist: "RAMONES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 225,
    color: "OFF WHITE",
    material: "50% cotton / 50% polyester",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR054SW_600x.jpg?v=1637778159",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR054SWDETAIL1_600x.jpg?v=1637778198",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR054SWDETAIL2_600x.jpg?v=1637778198",
    ],
  },
  {
    id: 51,
    category: "classic sweatshirts",
    name: "SEX PISTOLS NO FUTURE SWEATSHIRT",
    artist: "SEX PISTOLS",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 225,
    color: "OFF WHITE",
    material: "50% cotton / 50% polyester",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSP005SW_600x.jpg?v=1588101398",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSP005SWDETAIL1_600x.jpg?v=1588101404",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSP005SWDETAIL4_600x.jpg?v=1588101404",
    ],
  },
  {
    id: 52,
    category: "classic sweatshirts",
    name: "N.W.A. EAZY-E CREW FLEECE",
    artist: "N.W.A.",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 225,
    color: "DIRTY BLACK",
    material: "50% cotton / 50% polyester",
    countryOfOrigin: "USA",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS CUT, SEWN, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWNWA017SW_600x.jpg?v=1572983443",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWNWA017SWDETAIL-2_600x.jpg?v=1572983443",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWNWA017SWDETAIL-1_600x.jpg?v=1572983443",
    ],
  },
  {
    id: 53,
    category: "oversized hoodies",
    name: "SUBLIME 40 OZ. TO FREEDOM OVERSIZED HOODED SWEATSHIRT",
    artist: "SUBLIME",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 475,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "OUR OVERSIZED HOODED SWEATSHIRT IS COMPOSED OF HEAVY GAUGE, PREMIUM COTTON. EACH PIECE IS UNIQUELY KNIT, DYED, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES. THIS PIECE RUNS LARGE - MEN CAN SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR NORMAL SIZE FOR A MORE RELAXED, COMFORTABLE VIBE. WOMEN MAY SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR STANDARD SIZE FOR A MORE RELAXED, COMFORTABLE VIBE.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSUB001OHD.1_600x.jpg?v=1642726492",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSUB00OHDDETAIL1_600x.jpg?v=1642726492",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWSUB00OHDDETAIL3_600x.jpg?v=1642726492",
    ],
  },
  {
    id: 54,
    category: "oversized hoodies",
    name: "GUNS N' ROSES OVERSIZED HOODED SWEATSHIRT",
    artist: "GUNS N' ROSES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 475,
    color: "BLACK FADE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "OUR OVERSIZED HOODED SWEATSHIRT IS COMPOSED OF HEAVY GAUGE, PREMIUM COTTON. EACH PIECE IS UNIQUELY KNIT, DYED, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES. THIS PIECE RUNS LARGE - MEN CAN SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR NORMAL SIZE FOR A MORE RELAXED, COMFORTABLE VIBE. WOMEN MAY SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR STANDARD SIZE FOR A MORE RELAXED, COMFORTABLE VIBE.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/GNRHEAVYFLEECEFRONT4_600x.jpg?v=1573512060",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR082OHDDETAIL1-1_600x.jpg?v=1573512060",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR082OHDBACK2_600x.jpg?v=1573512060",
    ],
  },
  {
    id: 55,
    category: "oversized hoodies",
    name: "METALLICA WORLD TOUR OVERSIZED HOODED SWEATSHIRT",
    artist: "METALLICA",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 475,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "OUR OVERSIZED HOODED SWEATSHIRT IS COMPOSED OF HEAVY GAUGE, PREMIUM COTTON. EACH PIECE IS UNIQUELY KNIT, DYED, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES. THIS PIECE RUNS LARGE - MEN CAN SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR NORMAL SIZE FOR A MORE RELAXED, COMFORTABLE VIBE. WOMEN MAY SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR STANDARD SIZE FOR A MORE RELAXED, COMFORTABLE VIBE.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM085OHDFRONT-2_600x.jpg?v=1586370600",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM085OHDDETAIL1_600x.jpg?v=1586370600",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM085OHDBACK_600x.jpg?v=1586370600",
    ],
  },
  {
    id: 56,
    category: "oversized hoodies",
    name: "GUNS N' ROSES HERE TODAY...GONE TO HELL OVERSIZED HOODED SWEATSHIRT",
    artist: "GUNS N' ROSES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 475,
    color: "COAL PIGMENT",
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "OUR OVERSIZED HOODED SWEATSHIRT IS COMPOSED OF HEAVY GAUGE, PREMIUM COTTON. EACH PIECE IS UNIQUELY KNIT, DYED, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES. THIS PIECE RUNS LARGE - MEN CAN SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR NORMAL SIZE FOR A MORE RELAXED, COMFORTABLE VIBE. WOMEN MAY SIZE DOWN 1 FOR A MORE TRADITIONAL FIT - OR SELECT THEIR STANDARD SIZE FOR A MORE RELAXED, COMFORTABLE VIBE.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR095OHDFRONT_600x.jpg?v=1638766903",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR095OHDDETAIL1_600x.jpg?v=1638767435",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR095OHDBACK_600x.jpg?v=1638766903",
    ],
  },
  {
    id: 57,
    category: "one of a kind",
    name: "GUNS N' ROSES HERE TODAY...GONE TO HELL OVERSIZED HOODED SWEATSHIRT",
    artist: "GUNS N' ROSES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 1500,
    color: "army green",
    material: "100% cotton",
    countryOfOrigin: "USA",
    extraInfo:
      "VINTAGE MILITARY JACKET WITH EMBROIDERED PATCHES. HAND PAINTED TIGER ARTWORK. LIMITED EDITION PIN",
    description:
      "INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE. THIS GARMENT IS PATCHED, DISTRESSED, AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMWHPTIGERFRONT_600x.jpg?v=1605295164",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMWHPTIGERDETAIL1_600x.jpg?v=1605295164",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWMWHPTIGERBACK_600x.jpg?v=1605295164",
    ],
  },
  {
    id: 58,
    category: "one of a kind",
    name: "ROLLING STONES DRAGON HAND PAINTED JACKET",
    artist: "ROLLING STONES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 4100,
    material: "LEATHER",
    countryOfOrigin: "USA",
    extraInfo: "VINTAGE LEATHER JACKET WITH HANDPAINTED BACK & FRONT POCKET",
    description:
      "THIS GARMENT HAS BEEN PAINTED, DISTRESSED AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWRS227LJ-2_600x.jpg?v=1572918760",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWRS227LJDETAIL6-1_600x.jpg?v=1573004379",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWRS227LJ_600x.jpg?v=1572918760",
    ],
  },
  {
    id: 59,
    category: "one of a kind",
    name: "METALLICA JUMP IN THE FIRE DENIM JACKET",
    artist: "METALLICA",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 1200,
    color: "DENIM BLUE",
    material: "100% COTTON",
    countryOfOrigin: "USA",
    extraInfo:
      "VINTAGE DENIM JACKET WITH PATCHED BACK. CUSTOM PATCHES & LIMITED EDITION PIN",
    description:
      "THIS GARMENT HAS BEEN EMBROIDERED, DISTRESSED AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE OF A KIND.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM083DJ_600x.jpg?v=1572855373",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM083DJDETAIL3-1_600x.jpg?v=1572855373",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWM083DJ-2_600x.jpg?v=1572855373",
    ],
  },
  {
    id: 60,
    category: "one of a kind",
    name: "GUNS N' ROSES PARADISE CITY LEATHER VEST",
    artist: "GUNS N' ROSES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 2400,
    material: "LEATHER",
    countryOfOrigin: "USA",
    extraInfo:
      "VINTAGE LEATHER BIKER VEST WITH CHENILLE BACK PATCH. CUSTOM PATCHES & LIMITED EDITION PIN",
    description:
      "THIS GARMENT HAS BEEN DESIGNED, DISTRESSED AND FINISHED ENTIRELY BY HAND IN LOS ANGELES, CALIFORNIA. DUE TO THIS PROCESS, EVERY PIECE IS UNIQUE AND COMPLETELY ONE",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR086LJ-2_600x.jpg?v=1572902893",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR086LJDETAIL1-1_600x.jpg?v=1572902893",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWGR086LJ-1_600x.jpg?v=1572902893",
    ],
  },
  {
    id: 61,
    category: "one of a kind",
    name: "AC/DC WHO MADE WHO DENIM JACKET",
    artist: "AC/DC",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 2400,
    material: "100% cotton",
    countryOfOrigin: "USA",
    description:
      "THIS ONE OF A KIND GARMENT HAS BEEN REIMAGINED AND REDESIGNED ENTIRELY BY HAND AT OUR STUDIO IN LOS ANGELES, CALIFORNIA.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC000DJFRONTANDBACK-2_600x.jpg?v=1572893258",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC000DJDETAIL8-1_600x.jpg?v=1572893256",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWACDC000DJFRONTANDBACK-1_600x.jpg?v=1572893258",
    ],
  },
  {
    id: 62,
    category: "flannel",
    name: "RAMONES PATCHWORK FLANNEL",
    artist: "RAMONES",
    availableSizes: {
      xs: Math.floor(Math.random() * 9),
      s: Math.floor(Math.random() * 8),
      m: Math.floor(Math.random() * 7),
      l: Math.floor(Math.random() * 6),
      xl: Math.floor(Math.random() * 5),
      xxl: Math.floor(Math.random() * 5),
    },
    price: 690,
    material: "100% cotton",
    countryOfOrigin: "USA",
    extraInfo:
      "CUSTOM PRINTED PATCHES AND LIMITED EDITION PINS. INSPIRED BY A VINTAGE FIT - EACH PIECE IS UNISEX AND TRUE TO SIZE",
    description:
      "THIS ONE OF A KIND GARMENT HAS BEEN REIMAGINED AND REDESIGNED ENTIRELY BY HAND AT OUR STUDIO IN LOS ANGELES, CALIFORNIA.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR047FL-2_600x.jpg?v=1572914091",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR047FLDETAIL2_600x.jpg?v=1572914091",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/MWR047FL-1_600x.jpg?v=1572914091",
    ],
  },
  {
    id: 63,
    category: "accessories",
    name: "ROLLING STONES NECKERCHIEF",
    artist: "ROLLING STONES",
    price: 95,
    color: "OFF WHITE / VINTAGE BLACK",
    material: "100% silk",
    countryOfOrigin: "USA",
    availableSizes: "OS",
    description:
      "These slim 100% silk scarves are at home around your neck, pockets, bags, or wherever else needed.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/STONES8_fe4cbcc5-eb9d-452e-87a1-ce8d0af429f4_600x.jpg?v=1649372458",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/STONES1_600x.jpg?v=1649394994",
    ],
  },
  {
    id: 64,
    category: "accessories",
    name: "GRATEFUL DEAD NECKERCHIEF",
    artist: "GRATEFUL DEAD",
    price: 95,
    color: "OFF WHITE / VINTAGE BLACK",
    material: "100% silk",
    countryOfOrigin: "USA",
    availableSizes: "OS",
    description:
      "These slim 100% silk scarves are at home around your neck, pockets, bags, or wherever else needed.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/DEAD12_600x.jpg?v=1649443454",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/GRATEFULDEADSCARF5_600x.jpg?v=1649377268",
    ],
  },
  {
    id: 65,
    category: "accessories",
    name: "VINTAGE BANDANA BLACK",
    price: 30,
    color: "BLACK",
    material: "100% cotton",
    countryOfOrigin: "USA",
    availableSizes: "OS",
    description:
      "VINTAGE BANDANAS FROM OUR EVER INCREASING COLLECTION. EACH PIECE SLIGHTLY DIFFERENT THAN THE REST, WITH SLIGHT IMPERFECTIONS AND COLOR FADING ADDING TO THE CHARACTER AND HISTORY OF EACH PIECE.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/BLACKBANDANA_600x.jpg?v=1603150716",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/BLACKBANDANADETAIL1_600x.jpg?v=1603150722",
    ],
  },
  {
    id: 66,
    category: "accessories",
    name: "VINTAGE BANDANA RED FADE",
    price: 30,
    color: "RED FADE",
    material: "100% cotton",
    countryOfOrigin: "USA",
    availableSizes: "OS",
    description:
      "VINTAGE BANDANAS FROM OUR EVER INCREASING COLLECTION. EACH PIECE SLIGHTLY DIFFERENT THAN THE REST, WITH SLIGHT IMPERFECTIONS AND COLOR FADING ADDING TO THE CHARACTER AND HISTORY OF EACH PIECE.",
    image: [
      "https://cdn.shopify.com/s/files/1/1409/0868/products/REDBANDANA_600x.jpg?v=1603149862",
      "https://cdn.shopify.com/s/files/1/1409/0868/products/REDBANDANADETAIL1_600x.jpg?v=1603149870",
    ],
  },
];

export default products;
